import { PropsWithChildren } from "react";

import { Dialog, IDialogProps } from "@bps/fluent-ui";

interface JobsConfigurationDialogProps
  extends Pick<IDialogProps, "onDismiss"> {}

export const JobsConfigurationDialog: React.FC<PropsWithChildren<
  JobsConfigurationDialogProps
>> = ({ children, onDismiss }) => {
  return (
    <Dialog
      dialogContentProps={{
        showCloseButton: true,
        title: "Configure Jobs"
      }}
      minWidth="90%"
      maxWidth="90%"
      onDismiss={onDismiss}
      hidden={false}
    >
      {children}
    </Dialog>
  );
};
